import Box from '@mui/material/Box';
import DialogContentText from '@mui/material/DialogContentText';
import { useTranslation } from 'react-i18next';
import { Alert, Dialog, TextV2 } from '@insights-ltd/design-library/components';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';

type ConfirmOrgDialogProps = {
  open: boolean;
  isError: boolean;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const ConfirmOrgDialog = ({
  open,
  onClose,
  onConfirm,
  isError,
  isLoading,
}: ConfirmOrgDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      title={t('ui.event-management.learner.confirm-org.heading')}
      onClose={onClose}
      onSubmit={onConfirm}
      content={
        <>
          <DialogContentText id="alert-dialog-description">
            {t(
              'ui.event-management.learners.organisation.change-org.confirm-description',
            )}
          </DialogContentText>
          <Box
            sx={{
              mb: (theme) => theme.spacing(spacingSizeMap.M),
            }}
          />
          {isError ? (
            <Alert severity="error" data-testid="error-message">
              <TextV2 component="span" variant="bodyBold" color="error">
                {t('ui.event-management.learner.confirm-org.error')}
              </TextV2>
            </Alert>
          ) : (
            <Alert severity="error" data-testid="warning-message">
              <TextV2 component="span" variant="bodyBold" color="error">
                {t('ui.event-management.learner.confirm-org.body-bottom')}
              </TextV2>
            </Alert>
          )}
        </>
      }
      isLoading={isLoading}
      primaryButtonText={t('ui.event-management.learner.confirm-org.confirm')}
      secondaryButtonText={t('ui.event-management.learner.confirm-org.cancel')}
    />
  );
};

export default ConfirmOrgDialog;
